import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalModule } from 'ngx-bootstrap/modal';

import { QrProgressBarComponent } from './qr-progress-bar/qr-progress-bar.component';
import { QrSwitchComponent } from './qr-switch/qr-switch.component';
import { QrAccordionComponent } from './qr-accordion/qr-accordion.component';
import { QrConfirmModalComponent } from './qr-confirm-modal/qr-confirm-modal.component';

@NgModule({
  imports: [
    CommonModule,
    ModalModule.forRoot()
  ],
  declarations: [
    QrProgressBarComponent,
    QrSwitchComponent,
    QrAccordionComponent,
    QrConfirmModalComponent
  ],
  exports: [
    QrProgressBarComponent,
    QrSwitchComponent,
    QrAccordionComponent,
    QrConfirmModalComponent
  ]
})
export class UiComponentsModule { }



// WEBPACK FOOTER //
// /app/src/app/components/ui/ui.module.ts